import TermsActions from 'actions/TermsActions';
import { AA, Resource, Method } from 'sdk';
import TermsStore from 'stores/TermsStore';

class TermsActionCreator {
  fetchTerms(params) {
    const parameters = {
      ...params,
      locale: params.locale || 'en_US',
    };

    const headers = {
      'amzn-terms-and-conditions-key': TermsStore.getState().termsAndConditionsKey,
    };

    AA.api(Resource.terms, Method.get, parameters, headers).then((response) => {
      TermsActions.fetchSucceeded(response.data);
    }, (error) => {
      TermsActions.fetchFailed(error);
    });
  }

  bootstrapLegalData() {
    if (!document || !document.getElementById) return;
    const bootstrapDataContainer = document.getElementById('__data__');
    if (!bootstrapDataContainer || !bootstrapDataContainer.innerHTML) return;

    const bootstrapData = JSON.parse(bootstrapDataContainer.innerHTML);
    const a2cConfig = bootstrapData.a2c_config;

    const {
      privacyPolicyUrl,
      conditionsOfUseUrl,
      cookiePolicyUrl,
      termsAndConditionsKey,
    } = a2cConfig;

    TermsActions.setLegalData({
      privacyPolicyUrl,
      conditionsOfUseUrl,
      cookiePolicyUrl,
      termsAndConditionsKey,
    });
  }
}

export default new TermsActionCreator();
